import React, {useEffect, useState} from 'react'
import { useNavigate } from "react-router-dom";
import './MarketMenuItemDetailed.css';
import ClipLoader from "react-spinners/ClipLoader";
import LoadingPage from '../pages/LoadingPage';
import {Zoom} from 'react-awesome-reveal';
import AllergenDisclaimer from '../../policies/allergen_disclaimer.pdf';
import DropdownContentComponent from '../dropdowns/DropdownContentComponent';
import ServingsDropdown from "../market_menu/ServingsDropdown";

const MarketMenuItemDetailed = ({item, onAddToBasket, currentCatHandle}) => {
    const [itemQuantity, setItemQuantity] = useState(1);
    const [fillAddBsk, setFillAddBsk] = useState(false);
    const [variants, setVariants] = useState([]);
    const [selectedVariant, setSelectedVariant] = useState(null);

    useEffect(() => {
      if (item) {
        if (item.variants && item.variants.edges.length > 0) {
          // Capture all variants in a simplified format
          const allVariants = item.variants.edges.map(edge => ({
            price: parseFloat(edge.node.price.amount),
            servings: edge.node.selectedOptions[0].value, // Assuming "Servings" is always the first option
            id: edge.node.id // Keep track of the variant ID for future use
          }));
          setVariants(allVariants);
          setSelectedVariant(allVariants[0]); // Set the first variant as selected initially
        }
      }
    }, [item]);

    const handleVariantChange = (selectedVariantId) => {
      const selected = variants.find(variant => variant.id === selectedVariantId); // Find selected variant using the id
      console.log(selected); // Log the selected variant
      setSelectedVariant(selected); // Update selected variant
    };

    function increment() {
        setItemQuantity(function (prevCount) {
          return prevCount += 1;
        });
      }
    
    function decrement() {
      setItemQuantity(function (prevCount) {
          return itemQuantity > 1 ? (prevCount -= 1) : itemQuantity;
        });
    }
    const ingredients = item.metafields.find(field => field.key === "ingredients")?.value;
    const allergens = ['Eggs', 'Cereals Containing Gluten', 'Celery', 'Fish', 'Milk', 'Mustard', 'Nuts', 'Peanuts', 'Sesame Seeds', 'Soya', 'Lupin', 'Crustaceans', 'Molluscs', 'Sulphites'];
    const words = ingredients.split(/\s*,\s*/);
    

    const formattedIngredients = words.map((word, index) => {
      const matches = word.match(/\(([^)]+)\)/); // Extracts text within parentheses
      if (matches) {
        const allergenText = matches[1];
        if (allergens.includes(allergenText)) {
          return (
            <span key={index}>
              {word.replace(`(${allergenText})`, '')}
              <strong>{`(${allergenText})`}</strong>
              {index !== words.length - 1 ? ", " : ""}
            </span>
          );
        }
      } else if (allergens.includes(word)) {
        return (
          <span key={index}>
            <strong>{word}</strong>
            {index !== words.length - 1 ? ", " : ""}
          </span>
        );
      }
      return (
        <span key={index}>
          {word}
          {index !== words.length - 1 ? ", " : ""}
        </span>
      );
    });


    const override = {
      display: "flex",
      borderWidth: '5px',
      height: '50px',
      width: '50px',
      position:'absolute',
      left:'calc(50% - 25px)',
      top: 'calc(50% - 25px)',
      zIndex:'0'
    };

    const overrideSmall = {
      display: "flex",
      borderWidth: '3px',
      height: '22px',
      width: '22px',
      position:'absolute',
      left:'calc(50% - 11px)',
      top: 'calc(50% - 11px)',
      bottom:'45px',
      zIndex:'0'
    };

    let navigate = useNavigate();

    const getImageUrl = (item) => {
      return item.images?.edges?.[0]?.node?.src || "../../images/category_default.png"; // Use a default image if no URL is found
    };

  return (
    !item ? 
    <LoadingPage height="600px"/> 
    :
    <div className='item_detailed_page_wrapper'>
      
      <div className='item_detailed_option_container'>
      <Zoom triggerOnce={true}>
          <button className='cat_return_btn' onClick={() => navigate(`/market/${currentCatHandle}`)}>&#8678; {currentCatHandle.replace(/-/g, ' ').toUpperCase()}</button>
      </Zoom>
      </div>
      
      <Zoom triggerOnce={true} className='zoom-container'>
      <div className='detailed_wrapper'>
        <div className='detailed_container'>
        <div className='img_detailed_wrapper'>
          <img
              className='menu_item_img_detailed'
              src={getImageUrl(item)}
              alt={item.title.toUpperCase()}
              loading="eager">
          </img>
          <ClipLoader
            color={'#001e00'}
            loading={true}
            cssOverride={override}
            size={150}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
        <div className='detailed_info_wrapper'>
          <div className='detailed_container_info'>
              <h2>{item.title.toUpperCase()}</h2>
              <span className='price'>£{selectedVariant?.price?.toFixed(2) || "-"}</span>
              <div className='icon_txt_container' style={{margin: "5px 0 10px 0"}}>
                  {variants.length !== 0 && (
                      <>
                          <img
                              className={'menu_item_icon'}
                              alt='Group Icon'
                              src={require('./../../images/icon-group.png')}
                              loading="eager"
                              style={{margin: "2px 0 0 0"}}
                          />
                          {variants.length === 1 ?
                              <span className='menu_item_notice'>{selectedVariant.servings} servings</span>
                              :
                              <ServingsDropdown variants={variants} selectedVariant={selectedVariant} handleVariantChange={handleVariantChange}/>
                          }
                      </>
                  )}
              </div>
              <div className='icon_txt_container' style={{margin: "5px 0 30px 0"}}>
                <img
                  className={'menu_item_icon'}
                  alt='Calendar Icon'
                  src={require('./../../images/icon-calendar.png')}
                  loading="eager"
                />
                <span className='general_info'>{item.metafields.find(field => field.key === "days_notice")?.value} days notice required</span>
              </div>
              <div className='tags_container'>
                {item.tags.includes("Ready to eat") && <h4 className='tag ready_to_eat'>Ready to eat</h4>}
                {item.tags.includes("Requires re-heating") && <h4 className='tag requires_reheating'>Requires re-heating</h4>}
                {item.tags.includes("Eat same day") && <h4 className='tag eat_same'>Eat same day</h4>}
                {item.tags.includes("Gluten-free") && <h4 className='tag gluten'>Gluten-free</h4>}
                {item.tags.includes("Vegan") && <h4 className='tag vegan'>Vegan</h4>}
                {item.tags.includes("Vegetarian") && <h4 className='tag vege'>Vegetarian</h4>}
                {item.tags.includes("Freezable") && <h4 className='tag freezeable'>Freezable</h4>}
                {item.tags.includes("Frozen") && <h4 className='tag frozen'>Frozen</h4>}
                {item.tags.includes("Requires cooking") && <h4 className='tag requires_cooking'>Requires cooking</h4>}
              </div>
               <div className='divider'></div>
                <p>{item.description}</p>
               <div className='divider'></div>

          </div>
          <div className='quantity_container'>
                  <button type="button" className={itemQuantity === 1 ? 'increment_btn inactive' : 'increment_btn'} onClick={decrement}>-</button>
                  <span className='quantity'>{itemQuantity}</span>
                  <button type="button" className='increment_btn' onClick={increment}>+</button>
                  <button type="button" className={fillAddBsk ? 'add_to_basket_btn inactive_add' : 'add_to_basket_btn'}
                  onClick={() => {
                    if (selectedVariant) { // Ensure selectedVariant is set
                      onAddToBasket(itemQuantity, selectedVariant.id);
                      setFillAddBsk(true);
                      setTimeout(() => {
                          setFillAddBsk(false);
                      }, 1000);
                  }
                  }}
                  ><ClipLoader
                  color={'#fff'}
                  loading={fillAddBsk}
                  cssOverride={overrideSmall}
                  size={'50px'}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                  />ADD TO BASKET</button>
          </div>
        <div className={'item_info_container'}>
          <DropdownContentComponent btnTxt={'INGREDIENTS'} dropdownContent={
            <>
            <span className='item_info'>{formattedIngredients}</span>
            <span className='allergy_advice'>
              <b>ALLERGY ADVICE:</b> For allergens see ingredients in bold. We cannot guarantee suitability for people with allergies - see our{' '}
              <a href={AllergenDisclaimer} rel="noreferrer" target="_blank" style={{ color: 'blue', textDecoration: 'underline' }}>Allergen Disclaimer</a>
              {' '}for more info.
            </span>  
            </>
          }/>

          <DropdownContentComponent btnTxt={'COOKING INSTRUCTIONS'} dropdownContent={
            <>
            <span className='item_info'>
             {item.metafields.find(field => field.key === "cooking_instructions").value}
            </span> 
            </>
          }/>

          <DropdownContentComponent btnTxt={'STORAGE'} dropdownContent={
            <>
            <span className='item_info'>
            {item.metafields.find(field => field.key === "storage").value}
            </span> 
            </>
          }/>
        </div>

        </div>
        
      </div>
      
      </div>
      </Zoom>
      {/* <div className='disclaimer_container'>
        <h3 className='disclaimer_title'>DISCLAIMER:</h3>
        <span className='disclaimer'>Please note that items prepared in our kitchen may have been manufactured, processed, or stored in facilities that handle allergens. Despite our best efforts to prevent cross-contamination, there is a possibility that allergens could be present in any food item due to the shared equipment or storage areas. We take food safety seriously and strive to provide accurate ingredient information. However, we cannot guarantee that our items are entirely free from allergenic substances. We strongly recommend that individuals with severe allergies or sensitivities exercise caution and take necessary precautions when consuming our food products. If you require specific advice on any Chatters Market item, please don't hesitate to get in contact.</span>
      </div> */}
      </div>
  
  )
}

export default MarketMenuItemDetailed
